module.exports = __webpack_public_path__ + "static/img/cart-updown_8303731e15@2x.7d9dac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/cart-updown_8303731e15@2x.jpg
// module id = 721
// module chunks = 0 1 2 3 4 5 6 7 9 11 13